//helpers
import storage from 'shared/helpers/storage';

//constants
const NYKAA_CART_COUNT = 'CART_COUNT';
const NYKAA_CART_MERGE_SHOW = 'CART_MERGE_SHOW';

export const getCartCount = (): number | string | null =>
  storage.getItem(NYKAA_CART_COUNT, null, true);

export const removeCartCount = (): void => {
  storage.removeItem(NYKAA_CART_COUNT);
};

export const setCartCount = (count: number | string): void => {
  storage.setItem(NYKAA_CART_COUNT, count);
};

export const incrementCartCount = (incrementBy: number = 1) =>
  setCartCount(getCartCount() || 0 + incrementBy);

export const isShowCartMerge = (): boolean | null => storage.getItem(NYKAA_CART_MERGE_SHOW);

export const removeShowCartMerge = (): void => {
  storage.removeItem(NYKAA_CART_MERGE_SHOW);
};

export const setShowCartMerge = (isShow: boolean): void => {
  storage.setItem(NYKAA_CART_MERGE_SHOW, isShow);
};
